import React from 'react'
import SettingApiForm from '../components/setting/SettingFaturaForm'

const SettingIndex = () => {
    return (
        <>
            <SettingApiForm />
        </>
    )
}

export default SettingIndex